import { useTranslation } from "react-i18next";
import React from "react";
import { deleteSitemapSubGroup } from "../../../../../../axios/api/services";
import { VIEW_TYPES } from "../../../../../../config/view/types";
import { addViewObject } from "../../../../../../store/redux/slice/ViewData/viewDataPage";
import { toast } from "react-toastify";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { sitemapSection } from "../../../../../../utils/constants";
import { closeDeleteModal } from "../../../../../../store/redux/slice/ComponentsControl/sitemapControl";

const SitemapDeleteSubGroupDialog = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.sitemapControl.sections[sitemapSection.subGroup].modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeDeleteModal({ section: sitemapSection.subGroup }));
  };

  const onSuccess = (response) => {
    const viewType = VIEW_TYPES.SITEMAP_EDIT;
    const payload = { viewType, data: response };
    dispatch(addViewObject(payload));
    handleCloseDialog();
    toast.success(t("m.save.data.success"));
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => deleteSitemapSubGroup(id)}
      onSuccess={onSuccess}
      title={"t.sitemap.subgroup.delete.dialog"}
      message={"m.delete.sitemap.subgroup.warning.message"}
    />
  );
};

export default SitemapDeleteSubGroupDialog;
